import { render } from "./SubMenu.vue?vue&type=template&id=5e566e4b&scoped=true"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import "./SubMenu.vue?vue&type=style&index=0&id=5e566e4b&scoped=true&lang=css"
import "./SubMenu.vue?vue&type=style&index=1&id=5e566e4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e566e4b"]])

export default __exports__